import { Flex } from "@similarweb/ui-components/foundations";

import { WidgetContainer } from "app/components/React/WidgetContainer/WidgetContainer";
import { useCategoriesComparison } from "app/pages/industry-analysis/categories-context";
import { useTranslation } from "pro-features/components/WithTranslation";

import { DeviceDistributionComparisonShareBar } from "./DeviceDistributionComparisonShareBar";
import { DeviceDistributionComparisonSkeleton } from "./DeviceDistributionComparisonSkeleton";
import { useDeviceDistributionComparisonData } from "./useDeviceDistributionComparisonData";

export const DeviceDistributionComparisonWidget = () => {
    const t = useTranslation();
    const { categories } = useCategoriesComparison();
    const { data, isLoading, isError } = useDeviceDistributionComparisonData(categories);

    return (
        <WidgetContainer
            withBorder
            noData={isError}
            loaderHeight={225}
            isLoading={isLoading}
            LoaderComponent={<DeviceDistributionComparisonSkeleton />}
            title={t("market.research.overview.comparison.deviceDistribution.widget.title")}
            automationId="industry-analysis-overview-comparison-device-distribution"
        >
            <Flex
                gap="24px"
                padding="24px"
                flexDirection="column"
            >
                {data
                    ? Object.entries(data).map(([key, value]) => (
                          <DeviceDistributionComparisonShareBar
                              key={key}
                              data={value}
                              category={categories.find(({ category }) => category.forApi === key)}
                          />
                      ))
                    : null}
            </Flex>
        </WidgetContainer>
    );
};
